/* Vision Affichage — boite de depot de logo, utilisable partout.
   Expose window.__vaLogoAjout(retour) : ouvre le selecteur de fichier,
   valide, enregistre dans va_logos + va_logo, puis rappelle
   retour(bibliotheque, index) pour que le configurateur se mette a jour
   sans recharger la page. */
(function(){
  var LIB="va_logos",CLE="va_logo",NOM="va_logo_name",TON="va_logo_tone",SANS="va_sans_logo";
  var MAX=3*1024*1024;
  function lire(k){try{return localStorage.getItem(k)}catch(e){return null}}
  function poser(k,v){try{localStorage.setItem(k,v);return true}catch(e){return false}}
  function oter(k){try{localStorage.removeItem(k)}catch(e){}}
  function bib(){try{var a=JSON.parse(lire(LIB)||"[]");return Array.isArray(a)?a:[]}catch(e){return []}}
  function mot(texte,erreur){
    var d=document.getElementById("va-mot-logo");
    if(!d){d=document.createElement("div");d.id="va-mot-logo";document.body.appendChild(d)}
    d.textContent=texte;
    d.setAttribute("style","position:fixed;left:50%;transform:translateX(-50%);bottom:22px;z-index:2147483647;max-width:min(92vw,420px);padding:12px 16px;border-radius:14px;font:600 14px/1.35 system-ui,sans-serif;text-align:center;color:#fff;box-shadow:0 10px 30px rgba(0,0,0,.25);background:"+(erreur?"#b42318":"#0369a1"));
    clearTimeout(d.__t);d.__t=setTimeout(function(){d.remove()},erreur?5200:2600);
  }
  window.__vaLogoAjout=function(retour){
    var inp=document.createElement("input");
    inp.type="file";inp.accept="image/png,image/jpeg,image/jpg,image/svg+xml,image/webp,image/*";
    inp.setAttribute("style","position:fixed;left:-9999px;top:0;opacity:0");
    document.body.appendChild(inp);
    inp.addEventListener("change",function(){
      var f=inp.files&&inp.files[0];
      try{document.body.removeChild(inp)}catch(e){}
      if(!f)return;
      if(!/^image\//.test(f.type||"")){mot("Choisis un fichier image : PNG, JPG ou SVG.",1);return}
      if(f.size>MAX){mot("Ton fichier depasse 3 Mo. Reduis-le un peu et reessaie.",1);return}
      var r=new FileReader();
      r.onerror=function(){mot("Le fichier n a pas pu etre lu. Reessaie.",1)};
      r.onload=function(){
        var data=String(r.result||"");
        if(data.indexOf("data:")!==0){mot("Le fichier n a pas pu etre lu. Reessaie.",1);return}
        var nom=String(f.name||"logo").replace(/\.[^.]+$/,"").slice(0,60)||"logo";
        var a=bib(),i=-1,k;
        for(k=0;k<a.length;k++){if(a[k]&&a[k].data===data){i=k;break}}
        if(i<0){a.push({name:nom,data:data,tone:"color"});i=a.length-1}
        if(!poser(LIB,JSON.stringify(a))){mot("Le stockage de ton navigateur est plein. Supprime un ancien logo et reessaie.",1);return}
        poser(CLE,data);poser(NOM,a[i].name);poser(TON,a[i].tone||"color");oter(SANS);
        mot("Logo ajoute.");
        try{retour&&retour(a,i)}catch(e){}
      };
      r.readAsDataURL(f);
    });
    inp.click();
  };
})();